import { render, staticRenderFns } from "./ReportPanelSelector.vue?vue&type=template&id=45d3d8a2"
import script from "./ReportPanelSelector.vue?vue&type=script&lang=js"
export * from "./ReportPanelSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports